<template>
  <div style="margin-bottom:3rem">
    <v-layout>
      <v-flex xs5 sm5>
        <v-btn
          :class="{'filtr-active':showFilter}"
          @click="filterSwitched"
          >
          Filtry
        </v-btn>
        <v-btn
          fab small
          v-if="showFilter"
          @click="range++"
          >
          <v-icon small>add</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <div v-if="show">
      <div :key="i" v-for="i in range">
        <v-layout >
          <v-flex xs5 sm3 >
            <v-select
              @change="changeHandler"
              :items="fields"
              item-text="name"
              item-value="value"
              v-model="choosenFields[i]"
              :label="`${$t('form.inputs.select_field')}`"
            ></v-select>
          </v-flex>
          <v-flex xs5 sm3 >
            <v-text-field @change="changeHandler"
              style="margin-left:2rem;"
              v-model="search[i]"
              prepend-icon="search"
              label="Szukaj"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs2 sm2>
          <v-btn
          v-if="i!=1"
          style="margin-left:2rem;"
            fab small block
            @click="removeFiltr(i)">
            <v-icon small>remove</v-icon>
          </v-btn>
        </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/plugins/http'
import fieldType from '@/enums/fieldType'
import QueryConditionBuilder from '@/plugins/QueryConditionBuilder'
import InputHelper from '@/plugins/InputHelper'

export default {
  components: {

  },
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
    fields(){
      let fields =  this.$store.state.forms.schema.fields
      .filter(this.isEditableField)
      .map( field => { return { name : field.name, value:field.order } })
      return this.baseFieldsFilter.concat(fields)
    },
    show(){
      return this.showFilter
    }
  },
  data() {
    return {
      search:[],
      showFilter:false,
      range:1,
      choosenFields:[],
      lastCondition:"{}",
      baseFieldsFilter : [
        {name : "Imie", value: "name"},
        {name : "Nazwisko", value: "surname"}
      ]
    }
  },
  methods:{
    removeFiltr(index){
      this.choosenFields.splice(index,1);
      this.search.splice(index,1)
      this.range--;
      this.$emit('change-condition',this.buildCondition())
    },
  buildCondition(){
    let queryBuilder=new QueryConditionBuilder();
    let field;

    this.choosenFields.forEach((paramName,i)=>{
        if(QueryConditionBuilder.baseFields().includes(paramName)){
          queryBuilder.appendBaseFieldCondition(paramName, this.search[i])
        }else {
          field = this.$store.state.forms.schema.fields.find(function (el) {
            return el.order == paramName
          })
          queryBuilder.appendCondition(field, this.search[i])
        }
    })
    return queryBuilder.getConditions()
  },
  changeHandler(){
    let condition=this.buildCondition();
    let conditionLength = Object.keys(condition).length
    let strCondition = JSON.stringify(condition)

    if((conditionLength > 0 && strCondition != this.lastCondition) ||
      (conditionLength == 0 && strCondition != this.lastCondition) ){

        this.$emit('change-condition', condition)
        this.lastCondition = strCondition
    }
  },
  filterSwitched(){
    this.showFilter=!this.showFilter
    if(!this.showFilter){
      this.$emit('change-condition', {})
      this.choosenFields=[]
      this.search=[]
      this.range=1
  }
},
  isEditableField(field){
   return InputHelper.isEditableField(field)
    }
  }
}
</script>

<style>
.loading-circle {
  margin: 20px;
}
.apexcharts-canvas.dark {
  background: transparent !important;
}
.filtr-active {
  background-color: green !important;
}
</style>
